/* eslint-disable camelcase */
import types from '../types'
import Action from '../../types/Action'

const initialState = {
  loginUser: {
	  loading: true,
    data: []
  },
  user: {
    loading: true,
    data: []
  },
  updateUserPassword: {
    loading: true,
    data: []
  },
  resetPassword: {
	  loading: true,
    data: []
  },
  isAuth: false,
  authMember: {
	  loading: true,
    data: []
  },
  selectedLocationApplication: {
    location_application_id: -1,
    '12_bed_certification': false,
    application_type: '',
    approval_date: '',
    status: '',
    submit_date: '',
  },
  selectedProvider: {
    address_1: '',
    address_2: '',
    city: '',
    evips_id: -1,
    provider_id: -1,
    provider_name: '',
    status: '',
    state: '',
    tax_id_number: -1,
    zip_code: '',
    contact_name: '',
    contact_email_address: '',
    contact_phone_number: ''
  },
  selectedOrganization: {
    organization_id: -1,
    organization_address_1: '',
    organization_address_2: '',
    organization_city: '',
    organization_name: '',
    organization_state: '',
    organization_tax_id_number: '',
    organization_zip_code: '',
    organization_npi: '',
    organization_medicaid_id: '',
    organization_medicare_id: '',
    organization_first_name: '',
    organization_last_name: '',
    organization_email_address: ''
  },
  organizationView: true,
  organizationModal: false,
  addUserActivity: {
    loading: true,
    error: false,
    success: false,
    data: []
  },
}

const authenticationReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.LOGIN_USER_REQUESTED: {
      return {
        ...state,
        loginUser: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.LOGIN_USER_FULFILLED: {
      return {
        ...state,
        loginUser: {
		      ...state.loginUser,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
	  case types.LOGIN_USER_REJECTED: {
      return {
        ...state,
        loginUser: {
		      ...state.loginUser,
          loading: false,
          error: action.payload
        }
      }
    }
	  case types.AUTH_USER:{
      return {
        ...state,
        isAuth: action.payload
      }
    }
    case types.UNAUTH_USER:{
      return {
        ...state,
        isAuth: action.payload,
        user:{
          loading: false,
          error: false,
          success: false,
          data: []
        }
      }
    }
	  case types.GET_USER_BY_EMAIL_REQUESTED: {
      return {
        ...state,
        user: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.GET_USER_BY_EMAIL_FULFILLED: {
      return {
        ...state,
        user: {
		      ...state.user,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
  	case types.GET_USER_BY_EMAIL_REJECTED: {
      return {
        ...state,
        user: {
	    	  ...state.user,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.RESET_PASSWORD_REQUESTED: {
      return {
        ...state,
        resetPassword: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.RESET_PASSWORD_FULFILLED: {
      return {
        ...state,
        resetPassword: {
		      ...state.resetPassword,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.RESET_PASSWORD_REJECTED: {
      return {
        ...state,
        resetPassword: {
          ...state.resetPassword,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_USER_PASSWORD_REQUESTED: {
      return {
        ...state,
        updateUserPassword: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_USER_PASSWORD_FULFILLED: {
      return {
        ...state,
        updateUserPassword: {
          ...state.updateUserPassword,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.UPDATE_USER_PASSWORD_REJECTED: {
      return {
        ...state,
        updateUserPassword: {
          ...state.updateUserPassword,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_USER: {
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            first_name:action.payload.first_name,
            last_name:action.payload.last_name
          }
        }
      }
    }
    case types.AUTH_MEMBER_REQUESTED: {
      return {
        ...state,
        authMember: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.AUTH_MEMBER_FULFILLED: {
      return {
        ...state,
        authMember: {
		      ...state.authMember,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.AUTH_MEMBER_REJECTED: {
      return {
        ...state,
        authMember: {
          ...state.authMember,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.SET_USER: {
      return {
        ...state,
        user: {
          ...state.user,
          data: action.payload
        }
      }
    }
    case types.SET_SELECTED_PROVIDER:{
      return{
        ...state,
        selectedProvider: action.payload
      }
    }
    case types.SET_ORGANIZATION_VIEW:{
      return{
        ...state,
        organizationView: action.payload
      }
    }
    case types.SHOW_ORGANIZATION_MODAL:{
      return{
        ...state,
        organizationModal: action.payload
      }
    }
    case types.SET_SELECTED_ORGANIZATION:{
      return{
        ...state,
        selectedOrganization: action.payload
      }
    }
    case types.SET_PROVIDER_LIST:{
      return{
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            provider_data: action.payload
          }
        }
      }
    }
    case types.ADD_USER_ACTIVITY_REQUESTED: {
      return {
        ...state,
        addUserActivity: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.ADD_USER_ACTIVITY_FULFILLED: {
      return {
        ...state,
        addUserActivity: {
          ...state.addUserActivity,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.ADD_USER_ACTIVITY_REJECTED: {
      return {
        ...state,
        addUserActivity: {
          ...state.addUserActivity,
          loading: false,
          error: action.payload
        }
      }
    }
    default: {
      return state
    }
  }
}

export default authenticationReducer
